// extracted by mini-css-extract-plugin
module.exports = {"nowrap":"highlight__nowrap"};